module.exports = __webpack_public_path__ + "static/media/card.c64cd75c.png";